import React from 'react';

import { Artwork as ArtworkCell } from '../common/container/Cell.jsx';
import { ArtworkGridContainer, NoResults, Spaced, forResource, Title } from '../common/container/Container.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { ListArtworkAdd } from '../common/container/Popup.jsx';
import { Galleries as GalleriesSlider } from '../common/container/Slider.jsx';
import { Follow as FollowButton } from '../common/input/Button.jsx';

let _ArrivalsInst;
class _Arrivals extends React.Component {
    constructor(props) {
        super(props);

        let from, temp, to;
        temp = Artcloud.util.getparameterbyname('from');
        if (temp && temp.length > 0) {
            from = temp;
        }
        temp = Artcloud.util.getparameterbyname('to');
        if (temp && temp.length > 0) {
            to = temp;
        }
        this.state = {
            artwork: {
                loading: false,
                q: {
                    from: from,
                    limit: 20,
                    offset: 0,
                    to: to
                }
            },
            showFullBio: false
        };

        this.representationConfig = {
            items: 1,
            loop: true,
            margin: 5,
            nav: true,
            navText: ["", ""],
            rewindNav: true
        };

        this.getArtwork = this.getArtwork.bind(this);
        this.handleArtworkLikeChange = this.handleArtworkLikeChange.bind(this);
        this.handleBioToggle = this.handleBioToggle.bind(this);
        this.handleFollowChange = this.handleFollowChange.bind(this);
        this.handleListArtworkAddModalClose = this.handleListArtworkAddModalClose.bind(this);
        this.handleWaypointEnter = this.handleWaypointEnter.bind(this);
    }

    componentDidMount() {
        _ArrivalsInst = true;

        const component = this;
        component.props.onRegisterRequestCallback(function (responseData) {
            Artcloud.mkt.artists._isfollowing(responseData);

            if (responseData.Galleries) {
                responseData.Galleries.map(function (d) {
                    Artcloud.mkt.galleries._isfollowing(d);
                });
            }
            Artcloud.mkt._helpers.readall(responseData, responseData.Bio, 300);

            const id = responseData.ArtistId;
            component.getArtwork(id);
        });
    }

    componentWillUnmount() {
        _ArrivalsInst = undefined;

        if (this.artworkRequest) {
            this.artworkRequest.abort();
            this.artworkRequest = null;
        }
    }

    getArtwork(artistId) {
        const component = this;
        const state = component.state.artwork;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            artwork: state
        });
        component.artworkRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.artists.arrivals.get(artistId),
            state.q,
            function (responseData) {
                component.artworkRequest = null;

                responseData.Art.forEach(function (d) {
                    Artcloud.mkt.art._isfavorite(d);
                });

                if (!component.state.bannerArt && responseData.Art.length >= 5) {
                    component.setState({
                        bannerArt: responseData.Art.slice(-5)
                    });
                }

                let data = state.data || [];
                state.data = data.concat(responseData.Art);

                state.q.offset += responseData.Art.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    artwork: state
                });
            },
            function (jqXHR, textStatus) {
                component.artworkRequest = null;

                state.loading = false;
                component.setState({
                    artwork: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleArtworkLikeChange(d) {
        const state = this.state.artwork;
        let artwork;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.ArtId != d.ArtId) {
                continue;
            }
            artwork = temp;
            break;
        }
        if (!artwork) {
            return;
        }
        const component = this;
        Artcloud.mkt.art.updateFavorite(artwork.ArtId, !artwork.IsFavorite, artwork.Title, function () {
            if (!_ArrivalsInst) {
                return;
            }
            artwork.IsFavorite = !artwork.IsFavorite;
            component.setState({
                artwork: state,
                listArtworkAddModal: {
                    data: artwork,
                    visible: true
                }
            });
        });
    }

    handleBioToggle(event) {
        if (event) {
            event.preventDefault();
        }
        const showFullBio = !this.state.showFullBio;
        this.setState({
            showFullBio: showFullBio
        });
    }

    handleFollowChange() {
        const component = this;
        const artist = this.props.data;
        Artcloud.mkt.artists.updateFollowing(artist.ArtistId, !artist.IsFollowing, artist.Name, function (success) {
            if (success != true || !_ArrivalsInst) {
                return;
            }
            artist.IsFollowing = !artist.IsFollowing;
            component.props.onUpdateData(artist);
        });
    }

    handleListArtworkAddModalClose() {
        this.setState({
            listArtworkAddModal: undefined
        });
    }

    handleWaypointEnter() {
        if (!this.state.artwork.data || (this.state.artwork.data && this.state.artwork.q.offset >= this.state.artwork.total)) {
            return;
        }
        this.getArtwork(this.props.data.ArtistId);
    }

    render() {
        const data = this.props.data || {};
        const hasRepresentation = data.Galleries && data.Galleries.length > 0;

        let bio;
        if (data.Bio) {
            bio = (
                <div className={`grid grid--${hasRepresentation ? '7' : '12'}`}>
                    <div className="section__title section__title--small">
                        <h2>Bio</h2>
                    </div>
                    <p className="text--details">
                        {
                            !this.state.showFullBio &&
                            <span className="less">{data.Less}</span>
                        }
                        {
                            this.state.showFullBio &&
                            <span className="all" style={{ whiteSpace: 'pre-line' }}>{data.Bio}</span>
                        }
                        {
                            data.ReadAll &&
                            <a href="#" className="gallery--single__more" onClick={this.handleBioToggle}>{this.state.showFullBio ? 'Show Less' : 'Read All'}</a>
                        }
                    </p>
                </div>
            );
        }

        let imageStyle;
        if (data.Image && data.Image.MediumUrl && data.Image.MediumUrl.length) {
            imageStyle = { backgroundImage: `url('${data.Image.MediumUrl}')` };
        }
        let profileContent = (
            <div className="cover__name">
                <h1>{data.Name}</h1>
                <FollowButton data={data} onChange={this.handleFollowChange} />
            </div>
        );
        let coverImageStyle;
        if (data.Profile) {
            if (data.Profile.MediumUrl && data.Profile.MediumUrl.length) {
                coverImageStyle = { backgroundImage: `url('${data.Profile.MediumUrl}')` };
            }
            profileContent = (
                <React.Fragment>
                    <div className="cover__bg" style={imageStyle} />
                    {profileContent}
                </React.Fragment>
            )
        } else {
            if (imageStyle) {
                imageStyle["overflow"] = 'hidden';
            }
            profileContent = (
                <div className="container">
                    <div className="cover__bg" />
                    {profileContent}
                </div>
            );
        }
        profileContent = (
            <React.Fragment>
                <div className="masonry-grid">
                    {
                        this.state.bannerArt &&
                        this.state.bannerArt.map((d, i) => <div key={i} className="grid-item"><img src={`${d.Image ? d.Image.MediumUrl : undefined}`} /></div>)
                    }
                </div>
                <div className="cover__content">
                    {profileContent}
                </div>
            </React.Fragment>
        );
        return (
            <React.Fragment>
                {
                    data.Profile &&
                    <div className="cover__container cover--left">
                        <div className="cover__img" style={coverImageStyle} />
                        {profileContent}
                    </div>
                }
                {
                    !data.Profile &&
                    <div className="cover__container cover--fullwidth" style={imageStyle}>
                        {profileContent}
                    </div>
                }
                <div className="section container">
                    <Spaced>
                        {
                            !this.props.data &&
                            <LoadingIndicator />
                        }
                        <div className="container--spaced__row">
                            {
                                hasRepresentation &&
                                <GalleriesSlider
                                    className="grid grid--5"
                                    config={this.representationConfig}
                                    data={this.props.data.Galleries}
                                    id="representation"
                                    slideComponent={GallerySlide}
                                    sliderClassName="slider--single slider--spacedleft"
                                    title="Representation:"
                                    titleSmall={true} />
                            }
                            {bio}
                        </div>
                    </Spaced>
                </div>
                <Spaced className="section spacer--bottom">
                    <Title small={true}>
                        <h2>New Arrivals from {data.Name}</h2>
                    </Title>
                    {
                        this.state.artwork.data &&
                        this.state.artwork.data.length == 0 &&
                        <NoResults display="No Artwork" />
                    }
                    <ArtworkGridContainer sizeClassName="art__container grid--3" onWaypointEnter={this.handleWaypointEnter}>
                        {
                            this.state.artwork.data &&
                            this.state.artwork.data.length > 0 &&
                            this.state.artwork.data.map((d) => <ArtworkCell key={d.ArtId} className="grid--3" d={d} onLikeChange={this.handleArtworkLikeChange} col={4} />)
                        }
                    </ArtworkGridContainer>
                    {
                        this.state.artwork.loading &&
                        <LoadingIndicator />
                    }
                </Spaced>
                {
                    this.state.listArtworkAddModal &&
                    this.state.listArtworkAddModal.visible &&
                    <ListArtworkAdd data={this.state.listArtworkAddModal.data} onClose={this.handleListArtworkAddModalClose} />
                }
            </React.Fragment>
        );
    }
}

function GallerySlide(props) {
    const link = `/gallery/${props.d.Slug}`;
    return (
        <div className="gallery__box">
            {
                props.d.Image &&
                props.d.Image.MediumUrl &&
                props.d.Image.MediumUrl.length > 0 &&
                <a href={link}>
                    <img alt="{{this.Company}}" className="gallery__img" src={props.d.Image.MediumUrl} />
                </a>
            }
            <div className="gallery__box__info">
                <a href={link}>
                    <h4>{props.d.Company}</h4>
                </a>
                <span className="gallery__location">{props.d.Location}</span>
                <br />
                <FollowButton data={props.d} onChange={props.onFollowChange} />
            </div>
        </div>
    );
}

const Arrivals = forResource(_Arrivals, Artcloud.url.vendor.marketplace.artists.getid);
export default Arrivals;